import { routes } from '../admin/settings/routes';
import Dashboard from '../Components/Dashboard/Dashboard';
import Elements from '../Components/Elements/Elements';
import License from '../Components/Settings/License';
import Settings from '../Components/Settings/Settings';
import { Router, Route, Link } from './index';

const CustomRouter = () => (
  <Router routes={routes} defaultRoute={routes?.dashboard?.path}>
    <Route path={routes.dashboard.path}><Dashboard /></Route>
    <Route path={routes.settings.path}><Settings /></Route>
    <Route path={routes.elements.path}><Elements /></Route>
    <Route path={routes.license.path}><License /></Route>
  </Router>
);
export default CustomRouter;
